// extracted by mini-css-extract-plugin
export default {"paymentTypesPage":"PaymentTypesPage_paymentTypesPage__nukRH"};